import React, { useCallback, useEffect } from 'react';
import OnBoardingLayout from 'layout/onboarding';
import styles from '../index.module.sass';
import Button from 'components/button';
import FormInput from 'components/form-input';
import {
  useLoginFlowContext,
  CHANGE_EMAIL,
  CHANGE_EMAIL_ERROR_MESSAGE,
  useMarketingEmailOptedIn,
} from 'feature/login-flow/use-login-flow';
import amplitude from 'service/amplitude';
import { isNpcpay, termsUrl, privacyUrl, payTaipeiCardlessParkingTermsUrl } from 'config';
import Checkbox from 'components/checkbox';
import { Content } from "components/marketing-email-optedin-dialog";

const RegisterPage = () => {
  const { state, dispatch, register } = useLoginFlowContext();
  const { value: marketingEmailOptedIn, setValue: setMarketingEmailOptedIn } = useMarketingEmailOptedIn();

  useEffect(() => {
    amplitude.register_pageview();
  }, []);

  useEffect(() => {
    return () => {
      dispatch({
        type: CHANGE_EMAIL_ERROR_MESSAGE,
        payload: '',
      });
    };
  }, [dispatch]);

  const emailRef = useCallback(node => {
    if (node !== null) {
      node.focus();
    }
  }, []);

  const onEmailChanged = useCallback(
    email => {
      dispatch({
        type: CHANGE_EMAIL,
        payload: email,
      });
    },
    [dispatch]
  );

  const onRegister = useCallback(() => {
    amplitude.register_button_onClick();
    register(state.email, marketingEmailOptedIn);
  }, [state, register]);

  return (
    <>
      <OnBoardingLayout className={styles.register}>
        <div className={styles.top}>
          <div className={styles.title}>輸入電子信箱</div>
          <div className={styles.desc}>發票 / 訂單收據將會寄到此信箱</div>
          <div className={styles.form}>
            <FormInput
              onFocus={() => amplitude.register_email_onClick()}
              ref={emailRef}
              type="email"
              value={state.email}
              placeholder="輸入 Email 地址"
              onTextChanged={onEmailChanged}
              errorMessage={state.emailErrorMessage}
            />
          </div>
          <div className={styles.marketingEmail}>
            <Checkbox
              isChecked={marketingEmailOptedIn}
              onCheckChanged={() => {
                setMarketingEmailOptedIn(!marketingEmailOptedIn);
              }}
            />
            <div>
              <Content/>
            </div>
          </div>
        </div>

        <div className={styles.bottom}>
          <Button theme="blue" block={true} loading={state.loading} onClick={onRegister}>
            完成註冊
          </Button>
          {isNpcpay && (
            <div className={styles.aggreement}>
              使用及註冊麻吉付，即代表同意
              <br />
              <a href={termsUrl}>服務條款</a> / <a href={privacyUrl}>隱私權政策</a> /{' '}
              <a href={payTaipeiCardlessParkingTermsUrl}>北市停車條款</a>
            </div>
          )}
        </div>
      </OnBoardingLayout>
    </>
  );
};

export default RegisterPage;
